export default {
  PDF: 'application/pdf',
  MP4: 'video/mp4',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  BMP: 'image/bmp',
  EMBED: 'application/embed',
  EXTERNAL: 'application/external'
};